/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Cmp_TitleInputs */

const en_vc_page_cmp_title = /** @type {(inputs: Vc_Page_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft vs Illustrator (2026): Price, Features and Which to Choose`)
};

const zh_vc_page_cmp_title = /** @type {(inputs: Vc_Page_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 与 Illustrator 对比（2026）：价格、功能、怎么选`)
};

/**
* | output |
* | --- |
* | "VectorCraft vs Illustrator (2026): Price, Features and Which to Choose" |
*
* @param {Vc_Page_Cmp_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_cmp_title = /** @type {((inputs?: Vc_Page_Cmp_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Cmp_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_cmp_title(inputs)
	return zh_vc_page_cmp_title(inputs)
});
export { vc_page_cmp_title as "vc.page.cmp.title" }